/**
 * Progressive US phone formatting for controlled inputs (max 10 digits).
 * Example: (786) 123-4567
 *
 * @param {string} raw
 * @returns {string}
 */
export function formatPhoneInputValue(raw) {
  const digits = ('' + raw).replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) {
    return '';
  }
  if (digits.length <= 3) {
    return `(${digits}`;
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/**
 * Formats Phone Number
 *
 * @param {object} opts
 * @param {string} opts.phoneNumber
 * @returns {string}
 */
const formatPhoneNumber = (opts = {}) => {
  // Formats phone number. e.g. (123) 345-6789
  if (!opts.phoneNumber) return '';
  const cleaned = ('' + opts.phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return '';
};

export default formatPhoneNumber;
